import React, { useEffect, useState } from 'react'
import adminStyles from './adminStyles.module.css'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'

const EditTreatment = () => {
     const[timage,setTimage]=useState("")
     const[tname,setTname]=useState("");
     const[tdesc,setTdesc]=useState("");
    const{tid}=useParams();
    const navigate=useNavigate();

     useEffect(()=>{
    axios.get(`https://backendsurgylife-1.onrender.com/uploads/${tid}`)
    .then((res)=>{
        setTimage(res.data.image)
        setTname(res.data.tname)
        setTdesc(res.data.tdesc)
    })
    .catch((err)=>{
      alert("Error Fetching Treatments")
    })
  },[])

  const updateTreatmentData=(e)=>{
    e.preventDefault()
    axios.put(`https://backendsurgylife-1.onrender.com/uploads/${tid}`,{
      timage,
      tname,
      tdesc,
    })
  .then((res)=>{
    alert("Treatment Updated Successfully")
    navigate("/admindashboard/deletetreatment")
  })
   .catch((err)=>{
    alert("Error while Updating Treatment")
   })
  }

  return (
  <main className={adminStyles.adminMain}>
           
                   <section className={adminStyles.breadgum}>
                       <div className='container'>
                           <div className='row'>
                               <div className='col-md-12'>
                                   <h1>Edit Treatment</h1>
                               </div>
                           </div>
                       </div>
                   </section>

                                <section className='py-5'>
                                  <div className='container'>
                                     <div className='row'>
                                         <div className='col-md-6 mx-auto' >
                     
                                          <div className={adminStyles.bx_shadow}>
                                           <form onSubmit={updateTreatmentData}>



                      <div className='mb-3'>
                          <input type='file'
                          className='form-control'
                          onChange={(e)=>setTimage(e.target.files[0])}
                          />
                         
                      </div>
                                           <div className='mb-3'>
                     
                                                     <input 
                     
                                                      type='text'
                                                      name='tname'
                                                       placeholder='Treatment Name' 
                                                       className='form-control'
                                                       value={tname}
                                                       onChange={
                                                         (e)=>setTname(e.target.value)
                                                       }
                                                       />
                     
                                                       </div>
                     
                                                       <div className='mb-3'>
                     
                                                        <textarea 
                                                        className='form-control'
                                                        placeholder='Treatment Description'
                                                        value={tdesc}
                                                        onChange={
                                                         (e)=>setTdesc(e.target.value)
                                                        }
                                                        >
                     
                                                        </textarea>
                     
                                                       </div>
                     
                                                         <div className='mb-3'>
                                                           
                                                     <input 
                                                     type='submit' 
                                                     value='Update Treatment'
                                                     className='btn btn-success'/>  
                     
                                                         </div>
                     
                                                      </form>
                     
                                               
                     
                                                     </div>
                     
                                                    </div>
                                                </div>
                                            </div>
                                        </section>

                   </main>
  )
}

export default EditTreatment
